import React from 'react';

export const initXml = {
  blocks: {
    blocks: [
      {
        deletable: false,
        movable: false,
        type: 'BHOOT_initial_block',
        x: 50,
        y: 50,
      },
    ],
  },
};

/* eslint-disable */
export const categoryXml = (
  <xml>
    <category id="control" name="%{BKY_LANG_CATEGORY_CONTROLS}" categorystyle="control_category" iconclass="control" expandedclass="control-extended">
      <block type="BHOOT_repeat_forever" />
      <block type="BHOOT_pause_millis" />
      <block type="BHOOT_pause_smart" />
      <block type="BHOOT_control_loop_number" />

    </category>

    <category id="outputs" name="%{BKY_LANG_CATEGORY_ACTIONS}" categorystyle="outputs_category" iconclass="outputs" expandedclass="outputs-extended">
      <block type="BHOOT_play_tone" />
      <block type="BHOOT_led" />
      <block type="BHOOT_led_off" />
    </category>

    <category id="motors" name="%{BKY_LANG_CATEGORY_MOTION}" categorystyle="motors_category" iconclass="motors" expandedclass="motors-extended">
      <block type="BHOOT_motor_forward">
        <value name="NUM">
          <shadow type="math_whole_number">
            <field name="NUM">1</field>
          </shadow>
        </value>
      </block>
      <block type="BHOOT_motor_backward">
        <value name="NUM">
          <shadow type="math_whole_number">
            <field name="NUM">1</field>
          </shadow>
        </value>
      </block>
      <block type="BHOOT_motor_right">
        <value name="NUM">
          <shadow type="math_whole_number">
            <field name="NUM">1</field>
          </shadow>
        </value>
      </block>
      <block type="BHOOT_motor_left">
        <value name="NUM">
          <shadow type="math_whole_number">
            <field name="NUM">1</field>
          </shadow>
        </value>
      </block>
      <block type="BHOOT_line_follower_jr" />
    </category>

    <category id="screens" name="%{BKY_LANG_CATEGORY_LCD}" categorystyle="screens_category" iconclass="screens" expandedclass="screens-extended">
      <block type="BHOOT_matrix_8x8_junior" />
      <block type="show_string" />
    </category>

  </xml>
);
/* eslint-enable */
